import styles from './Sidebar.module.scss';

export const refinementListClassNames = {
  root: styles.refinementListRoot,
  searchBox: styles.refinementListSearchBox,
  noRefinementRoot: styles.noRefinementRoot,
  list: styles.refinementListList,
  item: styles.refinementListItem,
  label: styles.refinementListLabel,
  labelText: styles.refinementListLabelText,
  count: styles.refinementListCount,
  checkbox: styles.refinementListCheckbox,
  showMore: styles.refinementListshowMore,
  disabledShowMore: styles.refinementListDisabledShowMore,
};
